// components/Checkbox/Checkbox.js

import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const Checkbox = ({ checked, onChange }) => {
  const handleClick = () => {
    if (onChange) onChange(!checked);
  };

  return (
    <CheckboxContainer onClick={handleClick} aria-checked={checked} role="checkbox">
      <OuterBox checked={checked}>
        {checked && <CheckIcon />}
      </OuterBox>
    </CheckboxContainer>
  );
};

Checkbox.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default Checkbox;

// Styled Components
const CheckboxContainer = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
`;

const OuterBox = styled.div`
  align-items: center;
  border: 2px solid ${({ theme, checked }) => (checked ? theme.colors.brandMain : theme.border.defaultWeak)};
  border-radius: 4px;
  display: flex;
  height: 20px;
  justify-content: center;
  transition: border 0.3s ease;
  width: 20px;

  &:hover {
    // border-color: ${({ theme }) => theme.colors.brandMain};
    border-color: ${({ theme, checked }) => (checked ? theme.colors.brandMain : theme.border.defaultStrong)};
  }
`;

const CheckIcon = styled.div`
  width: 10px;
  height: 6px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.brandMain};
  border-left: 2px solid ${({ theme }) => theme.colors.brandMain};
  transform: rotate(-45deg);
  margin-top: -3px;
`;